export default class NavBar {
	constructor(name, element) {
		this.name = name;
		this.master = element;

		this.slaves = this.master.querySelectorAll(`[data-${this.componentName}-item]`);

		this.subNavs = this.master.querySelectorAll(`[data-${this.componentName}-sub]`);
		this.slavesHasSub = Array.prototype.slice.call(this.slaves).filter(item => item.getAttribute(`data-${this.componentName}-item`) === 'hasSub');

		this.params = {
			activeClass: this.master.getAttribute('data-active-class') || 'js-active',
			speed: this.master.getAttribute('data-speed') || 200,
			effect: this.master.getAttribute('data-effect') === 'slide' ? 'slide' : 'fade', // possible fade|slide
			closeSiblings: this.master.getAttribute('data-closeSiblings') !== 'false',
		};

		switch (this.params.effect) {
			case 'slide':
				this.jqEffect = {
					out: 'slideUp',
					in: 'slideDown',
					toggle: 'slideToggle',
				};
				break;
			case 'fade':
				this.jqEffect = {
					out: 'fadeOut',
					in: 'fadeIn',
					toggle: 'fadeToggle',
				};
				break;
		}
	}
	
	get componentName() {
		return 'NavBar';
	}

	start() {
		this.BindDOMEvents();
		this.slavesHasSub.forEach((item) => {
			this.bindEvents(item);
		});
	}

	BindDOMEvents() {
		document.addEventListener('click', (e) => {
			Array.prototype.slice.call(this.subNavs).forEach(item => {

				if (!$(item).is(e.target) && $(item).has(e.target).length === 0) {
					$(item).stop(true, true)[this.jqEffect.out](this.params.speed);
				}
			});
			Array.prototype.slice.call(this.slaves).forEach(item => {
				if (!$(item).is(e.target) && $(item).has(e.target).length === 0) {
					item.classList.remove(this.params.activeClass);
				}
			});
		});
	}

	bindEvents(element) {
		const subNav = element.querySelector(`[data-${this.componentName}-sub]`);
		const linkList = element.querySelectorAll(`[data-${this.componentName}-link]`);

		if (linkList.length === 0) return false;

		Array.prototype.slice.call(linkList).forEach(item => {
			item.onclick = (e) => {
				if (this.params.closeSiblings) {
					this.closeSiblings(element);
				}
				$(subNav).stop(true, true)[this.jqEffect.toggle](this.params.speed);
				element.classList.toggle(this.params.activeClass);

				e.stopPropagation();
				e.preventDefault();
			};
		});
	}

	closeSiblings(element) {
		const parentSubs = element.parentNode.querySelectorAll('[data-navbar-item="hasSub"]');

		for (let i = 0; i < parentSubs.length; i++) {
			if (parentSubs[i] !== element) {
				$(parentSubs[i].querySelector('[data-navbar-sub]'))
					.stop(true, true)
					[this.jqEffect.out](this.params.speed, () => {
					parentSubs[i].classList.remove(this.params.activeClass);
				})
			}
		}
	}
}
